<template>
    <div class="bg-wrap">
        <div class="content">
            <pdf
                    :page="pageNum"
                    :src="url"
                    @progress="loadedRatio = $event"
                    @num-pages="pageTotalNum=$event"
                    @loaded="loaded"
            ></pdf>
        </div>
        <div class="bottom">
            <div class="page">{{ pageNum }} / {{ pageTotalNum }}</div>
            <div class="btn">
                <button  @click="prePage">上一页</button>
                <button  @click="nextPage">下一页</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import {readingTime} from "@/assets/js/api";
    import {Indicator} from "mint-ui";


    export default {
        name: "PDF",
        components: {
            pdf
        },
        data() {
            return {
                url: this.$route.query.url,
                pageNum: 1,
                pageTotalNum: 1,
                loadedRatio: 0,
                timeId:null,
                docId:this.$route.query.docId,
            }
        },
        mounted() {
            this.getNumPages();
            this.time()
            this.loading();
        },
        destroyed(){
            console.log("page destroy");
            this.clearTime();
        },
        methods: {
            loading(){
                Indicator.open({
                    text: '加载中',
                    spinnerType: 'fading-circle'
                });
            },
            loaded(){
                Indicator.close()
            },
             time(){
                 if(this.docId==null) return
                 if(this.timeId==null){
                     let _this = this
                     this.timeId= setInterval(function () {
                         _this.readingTime(_this.docId)
                     },1000)
                 }
            },
            clearTime(){
                clearInterval(this.timeId)
            },

            async readingTime(docId){
                 await readingTime({docId})
            },
            getNumPages() {
                let loadingTask = pdf.createLoadingTask(this.url)
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages
                }).catch(err => {
                    console.error('pdf 加载失败', err);
                })
            },
            // 上一页
            prePage() {
                if(this.pageNum==1) return
                let page = this.pageNum
                page = page > 1 ? page - 1 : this.pageTotalNum
                this.pageNum = page
            },

            // 下一页
            nextPage() {
                if(this.pageNum>=this.pageTotalNum) {
                    this.$store.state.ksd_pdf = true//pdf已经阅读完
                    this.$router.go(-1);//关闭当前页
                    return
                }
                let page = this.pageNum
                page = page < this.pageTotalNum ? page + 1 : 1
                this.pageNum = page
            }
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        background: #FFF;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-flow: column;
    }
    .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        button{
            width: 80px;
            height: 30px;
            margin: 10px;
            background: #4caf50;
            border: transparent;
            border-radius: 5px;
            color: #FFF;
        }
    }
    .page{
        margin-top: 10px;
        font-weight: bold;
        font-size: 20px;
    }
    .content{
        overflow: scroll;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bottom{
        /*height: 20%;*/
    }
</style>